import * as Types from '../../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type ApproveCustomerMutationVariables = Types.Exact<{
  input: Types.ApproveCustomerCommand;
}>;


export type ApproveCustomerMutation = { __typename?: 'MutationModel', customers: { __typename?: 'CustomerMutationModel', approveCustomer: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const ApproveCustomerDocument = gql`
    mutation ApproveCustomer($input: ApproveCustomerCommand!) {
  customers {
    approveCustomer(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type ApproveCustomerMutationFn = Apollo.MutationFunction<ApproveCustomerMutation, ApproveCustomerMutationVariables>;

/**
 * __useApproveCustomerMutation__
 *
 * To run a mutation, you first call `useApproveCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCustomerMutation, { data, loading, error }] = useApproveCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCustomerMutation, ApproveCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveCustomerMutation, ApproveCustomerMutationVariables>(ApproveCustomerDocument, options);
      }
export type ApproveCustomerMutationHookResult = ReturnType<typeof useApproveCustomerMutation>;
export type ApproveCustomerMutationResult = Apollo.MutationResult<ApproveCustomerMutation>;
export type ApproveCustomerMutationOptions = Apollo.BaseMutationOptions<ApproveCustomerMutation, ApproveCustomerMutationVariables>;